import { CancelTokenSource } from 'axios'

import { facadeApi } from 'api'
import { UploadFileInfo } from 'types/files/files'

interface Params {
  uploadInfo: UploadFileInfo
  file: File
  source?: CancelTokenSource
}

export const uploadFileApi = ({ uploadInfo: { maxFileSize, url }, file, source }: Params) => {
  return facadeApi.put<''>(url, file, {
    cancelToken: source?.token,
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
      'x-goog-content-length-range': `1,${maxFileSize}`,
    },
  })
}
